const API_FAILURE_MESSAGE = "Sorry we are facing some issue, please try again";
const WEB_SPEECH_MESSAGE = "Sorry, web speech is not supported!";

export { API_FAILURE_MESSAGE, WEB_SPEECH_MESSAGE };
